// Main Javascript or common uses
(function ($) {
	// DeBounce Function
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	// Quick function for smooth scroll anchor links down the page
	$('a[href^="#"]').click(function (event) {
		// Ignore on product tabs or carousels
		if (
			$(this).parents("ul.tabs").length == 0 &&
			!$(this).hasClass("woocommerce-store-notice__dismiss-link") &&
			!$(this).hasClass("carousel-control-prev") &&
			!$(this).hasClass("carousel-control-next")
		) {
			event.preventDefault();

			var anchor = $(this).attr("href");

			window.scrollTo({
				top: $(anchor).offset().top,
				behavior: "smooth",
			});

			return false;
		}
	});

	$(document).on("change", ".variation-radios input", function () {
		$('select[name="' + $(this).attr("name") + '"]')
			.val($(this).val())
			.trigger("change");
	});

	// Search menu toggler
	var search = $(".search-toggler"),
		navToggle = $("#nav-toggler"),
		searchInitial = $("#search_initial"),
		searchList = $("#search_list"),
		searchPanel = $("#search-panel"),
		navPanel = $("#nav-panel"),
		$html = $("html"),
		$body = $("body"),
		$viewport = $(".viewport"),
		$navGlobal = $(".nav-global"),
		$navGlobalItems = $(".nav.nav-global").find("*");

	// Update to nave slider
	var r10Toggler = $(".r-10__link"),
		r15Toggler = $(".r-15__link"),
		subNavClose = $(".sub-nav__close"),
		mainMenu = $(".main"),
		r10Menu = $(".r-10__menu"),
		r15Menu = $(".r-15__menu"),
		rMenus = $(".r-10__menu, .r-15__menu");

	r10Toggler.click(function (e) {
		e.preventDefault();
		// console.log("r10");

		mainMenu.addClass("closed");
		subNavClose.addClass("open");
		r10Menu.addClass("open");
	});

	r15Toggler.click(function (e) {
		e.preventDefault();
		// console.log("r15");
		mainMenu.addClass("closed");
		subNavClose.addClass("open");
		r15Menu.addClass("open");
	});

	subNavClose.click(function (e) {
		e.preventDefault();
		// console.log("close");
		mainMenu.removeClass("closed");
		subNavClose.removeClass("open");
		rMenus.removeClass("open");
	});

	search.click(function (e) {
		e.preventDefault();

		$navGlobalItems.removeClass("active");
		navPanel.removeClass("d-flex");
		navToggle.removeClass("active");

		$(this).toggleClass("active");
		searchPanel.toggleClass("d-flex");
		searchPanel.find("input[type=search]").focus();

		if (searchPanel.hasClass("d-flex")) {
			$navGlobal.addClass("active");
			$body.addClass("menu-open");
		} else {
			$navGlobal.removeClass("active");
			$body.removeClass("menu-open");

			$navGlobalItems.addClass("active");
			navPanel.addClass("d-flex");
			navToggle.addClass("active");
		}

		if ($html.hasClass("parallax-enabled")) {
			$viewport.scrollTop(0);
		}
	});

	$("#modalMenu").on("hidden.bs.modal", function (e) {
		searchPanel.removeClass("d-flex");
		navPanel.removeClass("active").addClass("d-flex");
		searchInitial.removeClass("d-none");
		searchList.removeClass("d-flex").addClass("d-none");
		$body.removeClass("menu-open");
		searchPanel.find("input[type=search]").blur().val("");
	});

	// For ScrollTrigger v1+, it is no longer IE11 compatible.
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

	// Set up scroll detection triggers w/ ScrollTrigger.js
	if (!isIE11) {
		const trigger = new ScrollTrigger.default();

		trigger.add('[data-trigger="anim-default"]', {
			once: true,
			offset: {
				viewport: {
					x: 0,
					y: function (trigger, frame, direction) {
						// A float is read as percentage, so this is 1.0 is 100%. Integer is px
						// return trigger.visible ? 0 : 0.5;
						return 0.2;
					},
				},
			},
			toggle: {
				class: {
					in: "anim-in",
					// out: 'anim-out',
				},
				callback: {
					in: function () {
						// console.log('in');
					},
					out: function () {
						// console.log('out');
					},
				},
			},
		});
	}

	// Opt-in for tooltips. Only initialize if the data attributes exist
	$('[data-toggle="tooltip"]').tooltip();

	// Rifle Component Feature variables
	var $wireframe = $(".rifle-breakdown__hotspots"),
		$wfWrapper = $(".rifle-breakdown"),
		$window = $(window),
		calcScale = 1,
		wfWidth = 1680;

	// Create a function that will fire on browser resize.
	var wireframeResize = function () {
		wfWidth = $wfWrapper.width();

		if (wfWidth < 1680) {
			// Simple math to calculate a ratio based on the largest (original) size of the feature, and the current size.
			calcScale = wfWidth / 1680;
		} else {
			// The rifle feature caps out at 1680px wide, regardless of the dimensions of the wireframe in use. Therefore, set the feature to the default value for scale().
			calcScale = 1;
		}

		// Lastly, update the scale property to shrink the feature as needed.
		$wireframe.css("transform", "scale(" + calcScale + ")");
	};

	// Run first call to the videos.
	wireframeResize();

	// Set a debounce so the function doesn't fire for every pixel the browser is resized, only when it resizing briefly.
	var wireframeResizeListener = debounce(wireframeResize, 250);

	// Attach the debounced function to a jQuery window element.
	$window.resize(wireframeResizeListener);
})(jQuery);
